var VistaprintTenant = 'vistaprint';
var VistaTenant = 'vista';
var PromotiqueTenant = 'promotique';
var PayPalTenant = 'paypal';
var MasksTenant = 'masks';
var HOST_TO_TENANT = {
    'vistaprint': VistaprintTenant,
    'vpsvc': VistaprintTenant,
    'localhost': VistaprintTenant,
    'vista': VistaTenant,
    'promotique': PromotiqueTenant
};
var IREGULAR_PROMOTIQUE_HOSTS = [
    'brandstore.vistaprint.in',
    'novelty.vistaprint.jp'
];
var MASK_PATHS = [
    'masken',
    'mondkapjes',
    'masks',
    'masker',
    'maskit',
    'masque',
    'mascherine',
    'munnbind',
    'mascaras',
    'mascarillas',
    'munskydd'
];
var PAYPAL_PATHS = ['touch-free-payments'];
export var getCurrentTenant = function (host, path) {
    // Paypal and Masks are resolved from path
    if (path && path !== '/') {
        var pathParts = path.split('/');
        for (var j = 0; j < pathParts.length; j += 1) {
            if (MASK_PATHS.indexOf(pathParts[j].toLowerCase()) !== -1) {
                return MasksTenant;
            }
            if (PAYPAL_PATHS.indexOf(pathParts[j].toLowerCase()) !== -1) {
                return PayPalTenant;
            }
        }
    }
    // Rest is resolved from hostname
    var hostnameParts = host.split('.');
    var domainHostnameParts = hostnameParts.slice(-3);
    for (var _i = 0, IREGULAR_PROMOTIQUE_HOSTS_1 = IREGULAR_PROMOTIQUE_HOSTS; _i < IREGULAR_PROMOTIQUE_HOSTS_1.length; _i++) {
        var promotique_host = IREGULAR_PROMOTIQUE_HOSTS_1[_i];
        if (host.endsWith(promotique_host)) {
            return PromotiqueTenant;
        }
    }
    for (var i = domainHostnameParts.length - 1; i >= 0; i -= 1) {
        if (HOST_TO_TENANT[domainHostnameParts[i]] != undefined) {
            return HOST_TO_TENANT[domainHostnameParts[i]];
        }
    }
    throw new Error("Could not resolve tenant for host " + host + " and path " + path);
};
//# sourceMappingURL=data:application/json;base64,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